export const imgBaseUrl = 'https://www.xinghanmaterials.com';
